import React from 'react';
import { X } from 'lucide-react';
import { tagChipClass } from '../lib/tagColors';

// A single colored tag pill. `onRemove` is optional — omit it for read-only chips.
export default function TagChip({ tag, onRemove }) {
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs border ${tagChipClass(tag.color)}`}>
      {tag.name}
      {onRemove && (
        <button type="button" onClick={onRemove} className="hover:opacity-70" aria-label={`Remove ${tag.name}`}>
          <X className="h-3 w-3" />
        </button>
      )}
    </span>
  );
}
